import { z } from 'zod';

// Email regex (standard RFC 5322 simplified)
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Password regex: at least 6 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;

export const updateFormUserSchema = z.object({
    userName: z.string().trim()
        .min(3, { message: 'User name is required and must be at least 3 characters' }),

    // ✅ Zod v4 - use regex instead of deprecated .email()
    email: z.string().trim()
        .regex(emailRegex, { message: 'Invalid email address format' }),

    // ✅ Strong password validation
    password: z.string().trim().optional().refine(
        val => !val || passwordRegex.test(val),
        {
            message: 'Password must be at least 6 characters and include uppercase, lowercase, number, and special character'
        }
    ),

    plant: z.string().trim()
        .min(1, { message: 'Plant is required' }),

    designation: z.string().trim()
        .min(1, { message: 'Designation is required' }),

    employeeId: z.string().trim()
        .min(1, { message: 'Employee ID is required' }),

    phone: z.string().trim()
        .min(10, { message: 'Phone number must be at least 10 digits' })
});
export const createFormUserSchema = z.object({
    userName: z.string().trim()
        .min(3, { message: 'User name is required and must be at least 3 characters' }),

    // ✅ Zod v4 - use regex instead of deprecated .email()
    email: z.string().trim()
        .regex(emailRegex, { message: 'Invalid email address format' }),

    // ✅ Strong password validation
    password: z.string().trim()
        .min(1, { message: 'Password is required' }).refine(
            val => !val || passwordRegex.test(val),
            {
                message: 'Password must be at least 6 characters and include uppercase, lowercase, number, and special character'
            }
        ),

    plant: z.string().trim()
        .min(1, { message: 'Plant is required' }),

    designation: z.string().trim()
        .min(1, { message: 'Designation is required' }),

    employeeId: z.string().trim()
        .min(1, { message: 'Employee ID is required' }),

    phone: z.string().trim()
        .min(10, { message: 'Phone number must be at least 10 digits' })
});

